import React from 'react';

import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';

import './StoredValueCustomComponent.less';

/**
 * type: "stored-value" 
 * 组件：储值项列表组件
 * TODO: ；
 */

export default class StoredValueCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    this.getItemInfo(compindex, pageInstance);
  }

  //获取储值项
  getItemInfo = (compindex, pageInstance) => {
    let that = this;
    let data = {};
    app.sendRequest({
      url: '/index.php?r=AppShop/getStoredItems',
      success: function (res) {
        if (res.data.length != 0) {
          let newData = res.data;
          data['eles[' + compindex + '].stored_value_list'] = that.givingInstructions(newData);
        } 
        pageInstance.setData(data);
      }
    });
  }

  //拼接赠送说明
  givingInstructions = (data) => {
    for(let item of data){
      let dataArr =[];
      let instructions = '';
      item.g_price = Number(item.g_price);
      if (item.g_price){
        dataArr.push(item.g_price+'元');
      }
      item.g_integral = Number(item.g_integral);
      if (item.g_integral){
        dataArr.push(item.g_integral+'积分');
      }
      if (item.g_vip_card && item.g_vip_card.title){
        dataArr.push(item.g_vip_card.title);
      }
      if (item.g_coupon_list && item.g_coupon_list.length){
        dataArr.push(item.g_coupon_list[0].num + '张' + item.g_coupon_list[0].title);
      }
      for(let i=0;i<dataArr.length;i++){
        if (i != dataArr.length-1){
          instructions = instructions+dataArr[i]+'、';
        }else{
          instructions = instructions + dataArr[i];
        }
      }
      if(instructions){
        item.instructions = '赠送'+instructions;
      }
     
    }
    return data
  }

  //跳转充值详情
  turnToStoredValue = (event) => {
    let sotredId = event.currentTarget.dataset.storedid;
    let path = 'recharge?storedId='+sotredId;
    app.turnToPage(path);
  }

  //立即充值按钮
  gotoRecharge = (event) => {
    let that = this;
    let param = {
      type: 1
    }
    param['stored_id'] = event.currentTarget.dataset.storedid;
    param['form_id'] = event.detail.formId;
    app.sendRequest({
      url: '/index.php?r=AppShop/creatStoredItemOrder',
      data: param,
      success: function (res) {
        if(!res.status){
          let orderId = res.data;
          // app.sendRequest({
          //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
          //   data: {
          //     order_id: orderId
          //   },
          //   success: function (res) {
          //     var param = res.data;
          //     param.orderId = orderId;
          //     param.success = function () {
          //       app.showToast({
          //         title: '充值成功',
          //         success: function () {
          //           setTimeout(function () {
          //             app.turnToPage('/eCommerce/pages/balance/balance');
          //           }, 1500);
          //         }
          //       });
          //     };
          //     param.fail = function () {
          //     }
          //     app.wxPay(param);
          //   },
          //   fail: function () {
          //     app.showToast({
          //       title: res.data,
          //     });
          //   }
          // });
          app.goPay({
            orderId: orderId,
            successUrl: '/balance'
          })
        }else{

        }
      
      },
    });
    event.stopPropagation();
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    // 组件样式
    let styleObj = convertStyleData(data.style);
    let color = customFeature.styleColor;

    return (
      <div className="custom-component stored-value" style={styleObj}>
        {data.stored_value_list && data.stored_value_list.length !==0 && data.stored_value_list.map((item, index) =>
          <div className="value-item" key={index} style={{borderTopColor: color}}
            onClick={this.turnToStoredValue}
            data-storedid={item.id}
            >
            <div className="item-info">
              <div className="pirce-info">
                <div className="title">{item.price}元储值金</div>
                <div className="gift">{item.instructions}</div>
              </div>
              <div className="btn-wrap">
                <div className="btn" style={{backgroundColor: color}}
                  onClick={this.gotoRecharge}
                  data-storedid={item.id}
                  >立即充值</div>
                <div className="fir-color" style={{backgroundColor: color}}></div>
                <div className="sec-color" style={{backgroundColor: color}}></div>
                <div className="thi-color" style={{backgroundColor: color}}></div>
              </div>
            </div>
            <div className="desc">
              说明：{item.description_type == 1 ? <span>{item.description}</span> : <span>请查看详情</span> }
              </div>
          </div>
        )}
        {data.stored_value_list && data.stored_value_list.length ===0 &&
          <div>暂无储值</div>
        }
      </div >
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/stored-value-custom-component/StoredValueCustomComponent.jsx